import React, {useEffect} from "react";
import { Button } from "framework7-react";

interface IcustomButtonProps {
    btnText?: string; // set button text which is conditional
    btnId?: string; // set button id which is conditional
    btnClass?: any; // set button class
    children?: any; // set any control which is conditional
    popupOpen?: string; // set for open popup which is conditional
    popupClose?: boolean; // set for close popup which is conditional
    handleChangeValue?: (any); // set onclick event
    outline?: boolean; // button property which is conditional
    round?: boolean; // button property which is conditional
    disabled?: boolean; // button property to disable it
    color?: string; // button property to display color
    isFill?: boolean; //check when true then fill attribute for button otherwise not supported
    style?: any;//set style which apply dynamic
    modelId?: string;
    ariaDisabled?: boolean; // ADA: mark a visually-disabled button as disabled for screen readers
    href?: any; // underlying anchor href; pass false to render a non-focusable button (ADA)
    ariaLabel?: string; // ADA: override the accessible name for the button
    type?: 'button' | 'submit' | 'reset'; // forces F7 to render a native <button> element instead of <a>
}

const YcustomButton: React.FC<IcustomButtonProps> = ({
    children,
    btnText,
    btnId,
    btnClass,
    handleChangeValue,
    outline,
    popupClose,
    round,
    disabled,
    color,
    popupOpen,
    isFill,
    style,
    modelId,
    ariaDisabled,
    href,
    ariaLabel,
    type
}) => {

    // A button is "disabled" for screen readers if disabled/ariaDisabled is set OR it carries the
    // visual-disabled class (btn-disbled) used across the app. aria-disabled => NVDA reads "unavailable".
    const isAriaDisabled = disabled || ariaDisabled || /btn-dis(b|ab)led/.test(String(btnClass || "")) || undefined;

    useEffect(() => {
        if (btnId) {
          let lastElement = document.getElementById(btnId) as any;
          if (lastElement) {
            if (lastElement.addEventListener) {
              lastElement.addEventListener('keydown', onKeyDownOpenPopup, false);
            }
          }
        }
      }, [btnId])

      const onKeyDownOpenPopup = (e) => {
        if (e.keyCode === 13) {
          let mainModel;
          if(modelId){
            mainModel = document.querySelector(`#${modelId}`) as any
          }
        //   else{
        //     mainModel = document.querySelector(`.${modelName}`) as any
        //   }
          let focusedElement = mainModel?.getElementsByTagName("a") as any;
          setTimeout(() => {
            if(focusedElement){
                focusedElement[0]?.focus();
            }
          }, 500);
        }
      }

    return (
        <Button id={btnId} href={href} type={type} className={btnClass ? "customBtn " + btnClass : "customBtn"} color={color} outline={outline} round={round} popupClose={popupClose} popupOpen={popupOpen} onClick={handleChangeValue} disabled={disabled} style={style} aria-disabled={isAriaDisabled} aria-label={ariaLabel}>
            {btnText}
            {children}
        </Button>
    );
};

export default YcustomButton;
